module.exports = __webpack_public_path__ + "img/15.faf17e98.webp";